import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const CustomerListDetails = () => { 
  const [customers, setCustomers] = useState([]); 

  useEffect(() => { 
    const fetchCustomers = async () => { 
      try { 
        const url = `${API_DOMAIN}${API_ROUTES.customer}`; 
        const token = localStorage.getItem('token'); 
         
        const response = await axios.get(url, { headers }); 
        setCustomers(response.data); 
      } catch (error) { 
        console.error('Error fetching customers:', error); 
      } 
    }; 

    fetchCustomers(); 
  }, []); 

  const columns = [ 
    { label: 'Name', value: 'name' }, 
    { label: 'Email', value: 'email' }, 
    { label: 'Phone', value: 'phone' }, 
    { label: 'Address', value: 'address' }, 
    { label: 'Created At', value: 'created_at' }, 
  ]; 

  const handleViewDetails = (customerId) => { 
    //console.log('View Details', customerId); 
    const encodedId = btoa(customerId);
    window.location.href = `/customer/details/${encodedId}`; 
  }; 

  const actionButtons = [ 
    { label: 'View Details', handler: handleViewDetails }, 
  ]; 

  return <ListTemplate columns={columns} data={customers} actionButtons={actionButtons} />; 
}; 

export default CustomerListDetails;